<template>
<v-dialog v-model="show" width="25%">
  <v-card :max-height="$vuetify.breakpoint.height * 0.45">
    <v-card-title>
      <span>{{ $t('removeParserOutdates') }}</span>
      <v-spacer/>
      <v-btn icon @click="closeCleaningDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <p>{{ $t('periodLabel') }}</p>
      <v-select :placeholder="$t('periodPlaceholder')" v-model="form.period" :items="periods"></v-select>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn type="button" @click="clearOutdated" tile color="error">
        <span class="hidden-sm-and-down">{{ $t('periodButton') }} </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "CleaningDialog",
  data () {
    return {
      form: {
        period: null
      }
    }
  },
  methods: {
    closeCleaningDialog () {
      this.$store.dispatch('setCleaningDialogStatus', false)
    },
    clearOutdated () {
      this.$http.post('api/v2/auth/remove-outdated', this.form)
      .then(() => {
        this.closeCleaningDialog()
        this.$http.get('api/v2/auth/run-cleaning')
      })
    }
  },
  computed: {
    show: {
      get () {
        return this.$store.getters.GET_CLEANING_DIALOG_STATUS
      },
      set (value) {
        this.$store.dispatch('setCleaningDialogStatus', value)
      }
    },
    periods () {
      return this.$t('periods')
    }
  }
}
</script>

<style scoped>

</style>